import { Component, OnInit } from '@angular/core';
import {MatDialog , MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-pyramidhome',
  templateUrl: './pyramidhome.component.html',
  styleUrls: ['./pyramidhome.component.css']
})
export class PyramidhomeComponent implements OnInit {

  ngOnInit() {}

  constructor(public dialog: MatDialog) {}

  openDialog(val :string): void {

    if(val == 'FeedbackLoops')
    {
      const dialogRef = this.dialog.open(FeedBackLoops, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ContractMods') 
    {
      const dialogRef = this.dialog.open(ContractMods, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'MELProducts') 
    {
      const dialogRef = this.dialog.open(MELProducts, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'Monitoring') 
    {
      const dialogRef = this.dialog.open(Monitoring, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'PortfolioReviews') 
    {
      const dialogRef = this.dialog.open(PortfolioReviews, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    } //
    else if(val == 'ActivityDesign') 
    {
      const dialogRef = this.dialog.open(ActivityDesign, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'AfterActionReviews') 
    {
      const dialogRef = this.dialog.open(AfterActionReviews, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ActivityWorkplanRevisions') 
    {
      const dialogRef = this.dialog.open(ActivityWorkplanRevisions, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'AllStaffMeeting') 
    {
      const dialogRef = this.dialog.open(AllStaffMeeting, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'InformalLearning') 
    {
      const dialogRef = this.dialog.open(InformalLearning, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'IPMeetings') 
    {
      const dialogRef = this.dialog.open(IPMeetings, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'LearningEvents') 
    {
      const dialogRef = this.dialog.open(LearningEvents, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'MissionLeadership') 
    {
      const dialogRef = this.dialog.open(MissionLeadership, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ProjectDesign') 
    {
      const dialogRef = this.dialog.open(ProjectDesign, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'Retreats') 
    {
      const dialogRef = this.dialog.open(Retreats, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'SeniorManTeam') 
    {
      const dialogRef = this.dialog.open(SeniorManTeam, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'SysMap') 
    {
      const dialogRef = this.dialog.open(SysMap, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'DecisionTree') 
    {
      const dialogRef = this.dialog.open(DecisionTree, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ImplementationLetter') 
    {
      const dialogRef = this.dialog.open(ImplementationLetter, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'LearningAgenda') 
    {
      const dialogRef = this.dialog.open(LearningAgenda, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'LearningNetwork') 
    {
      const dialogRef = this.dialog.open(LearningNetwork, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ODAssessment') 
    {
      const dialogRef = this.dialog.open(ODAssessment, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'ProjectImplementation') 
    {
      const dialogRef = this.dialog.open(ProjectImplementation, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'StakeholderEngagement') 
    {
      const dialogRef = this.dialog.open(StakeholderEngagement, {
        width: '70%', height: '60%'
        //data: {name: this.name, animal: this.animal}
      });
    }
    else if(val == 'WhatsThis') 
    {
      const dialogRef = this.dialog.open(WhatsThis, {
        width: '60%', height: '80%'
        //data: {name: this.name, animal: this.animal}
      });
    }

    //AfterActionReviews
    //dialogRef.afterClosed().subscribe(result => {
    //  console.log('The dialog was closed');
    //  //this.animal = result;
    //});
  }

}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-feedbackloops.html',
})
export class FeedBackLoops {
  constructor(
    public dialogRef: MatDialogRef<FeedBackLoops>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-contractmodifications.html',
})
export class ContractMods {
  constructor(
    public dialogRef: MatDialogRef<ContractMods>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-melproducts.html',
})
export class MELProducts {
  constructor(
    public dialogRef: MatDialogRef<MELProducts>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-monitoring.html',
})
export class Monitoring {
  constructor(
    public dialogRef: MatDialogRef<Monitoring>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-potfolioreviews.html',
})
export class PortfolioReviews {
  constructor(
    public dialogRef: MatDialogRef<PortfolioReviews>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-activitydesign.html',
})
export class ActivityDesign {
  constructor(
    public dialogRef: MatDialogRef<ActivityDesign>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-afteractionreviews.html',
})
export class AfterActionReviews {
  constructor(
    public dialogRef: MatDialogRef<AfterActionReviews>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-activityworkplanrevisions.html',
})
export class ActivityWorkplanRevisions {
  constructor(
    public dialogRef: MatDialogRef<ActivityWorkplanRevisions>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-allstaffmeeting.html',
})
export class AllStaffMeeting {
  constructor(
    public dialogRef: MatDialogRef<AllStaffMeeting>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-informallearning.html',
})
export class InformalLearning {
  constructor(
    public dialogRef: MatDialogRef<InformalLearning>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-ipmeetings.html',
})
export class IPMeetings {
  constructor(
    public dialogRef: MatDialogRef<IPMeetings>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-learningevents.html',
})
export class LearningEvents {
  constructor(
    public dialogRef: MatDialogRef<LearningEvents>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-missionleadership.html',
})
export class MissionLeadership {
  constructor(
    public dialogRef: MatDialogRef<MissionLeadership>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-projectdesign.html',
})
export class ProjectDesign {
  constructor(
    public dialogRef: MatDialogRef<ProjectDesign>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-retreats.html',
})
export class Retreats {
  constructor(
    public dialogRef: MatDialogRef<Retreats>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-seniormanteam.html',
})
export class SeniorManTeam {
  constructor(
    public dialogRef: MatDialogRef<SeniorManTeam>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-sysmap.html',
})
export class SysMap {
  constructor(
    public dialogRef: MatDialogRef<SysMap>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-decisiontree.html',
})
export class DecisionTree {
  constructor(
    public dialogRef: MatDialogRef<DecisionTree>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-implementationletter.html',
})
export class ImplementationLetter {
  constructor(
    public dialogRef: MatDialogRef<ImplementationLetter>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-learningagenda.html',
})
export class LearningAgenda {
  constructor(
    public dialogRef: MatDialogRef<LearningAgenda>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-learningnetwork.html',
})
export class LearningNetwork {
  constructor(
    public dialogRef: MatDialogRef<LearningNetwork>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-odassessment.html',
})
export class ODAssessment {
  constructor(
    public dialogRef: MatDialogRef<ODAssessment>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-projectimplementation.html',
})
export class ProjectImplementation {
  constructor(
    public dialogRef: MatDialogRef<ProjectImplementation>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-stakeholderengagement.html',
})
export class StakeholderEngagement {
  constructor(
    public dialogRef: MatDialogRef<StakeholderEngagement>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  //templateUrl: 'dialog-overview-example.html',
  templateUrl: 'comp-whatsthis.html',
})
export class WhatsThis {
  constructor(
    public dialogRef: MatDialogRef<WhatsThis>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}